import wx from 'weixin-js-sdk';
import utils from 'common/utils';
import fetch from 'common/services/fetch';
import store from 'common/services/storage';
import config from '../config';
// import shareTip from 'components/mtShareTip';

const jobQueue = {
  queue: [],
  enqueue(resolve, reject, name, param) {
    this.queue.push({
      resolve, reject, name, param,
    });
  },
  flushQueue() {
    if (!this.isWxReady) {
      return;
    }
    const { wrapper } = this;
    if (!wrapper) {
      return;
    }
    const targetArray = this.queue;
    this.queue = [];
    // clear queue before run in order to prevent infinite loop
    targetArray.forEach((target) => {
      wrapper[target.name](target.resolve, target.reject, ...target.param);
    });
  },
  wrapper: null,
  isWxReady: false,
};

/* eslint-disable */
const wxWrapper = {
  getWxParam(it) {
    const url = location.href.split('#')[0];
    fetch.post('/weixin/sign', { url: encodeURIComponent(url) }, {
      raw: true,
      silent: true,
    }).then((res) => {
      if (res.data) {
        it.next(res.data);
      }
    });
  },
  // wx.config是一个异步操作
  setWxConfig(param, it, queue) {
    wx.config({
      debug: config.WX_DEBUG,
      appId: param.appid,
      timestamp: param.timestamp,
      nonceStr: param.nonceStr,
      signature: param.signature,
      jsApiList: config.WX_API_LIST,
    });
    wx.ready(() => {
      queue.isWxReady = true;
      it.next();
    });
    wx.error((res) => {
      console.log(res);
    });
  },
  /*
    依赖ready，页面加载时就需要触发的api
  */
  // 配置微信配置信息,
  setWxShare(resolve, reject, shareInfo, shareCallback, it) {
    if (utils.isEmpty(shareInfo)) {
      return;
    }

    // 兼容接口
    shareInfo.link = shareInfo.link || shareInfo.url;
    shareInfo.imgUrl = shareInfo.imgUrl || shareInfo.logo;

    this.showMenu(config.WX_SHARE_MENU_LIST);
    shareInfo.link = shareLinkConstructor(shareInfo.link);
    // 分享给朋友
    wx.onMenuShareAppMessage(Object.assign({
      success() {
        shareCallbackRunner('shareAppMessage', shareInfo.link, shareCallback);
      },
      cancel() {
      },
    }, shareInfo));
    // 分享朋友圈
    wx.onMenuShareTimeline(Object.assign({
      success() {
        shareCallbackRunner('shareTimeline', shareInfo.link, shareCallback);
      },
      cancel() {
      },
    }, shareInfo));
    wx.onMenuShareQQ(Object.assign({
      success() {
        shareCallbackRunner('shareQQ', shareInfo.link, shareCallback);
      },
      cancel() {
      },
    }, shareInfo));
    wx.onMenuShareQZone(Object.assign({
      success() {
        shareCallbackRunner('shareQzone', shareInfo.link, shareCallback);
      },
      cancel() {
      },
    }, shareInfo));

    if (it) {
      // cannot call it directly
      setTimeout(() => {
        it.next();
      });
    }

    function shareCallbackRunner(shareChannel, link, currentShareCallback) {
      // shareTip.hide();
      setTimeout(() => {
        if (currentShareCallback) {
          currentShareCallback(shareChannel);
        } else {
          productDetailPostShareHandler(shareChannel, link);
        }
      }, 500);
    }

    function productDetailPostShareHandler(shareMethod, link) {
      function isSharingProductDetailUrl(url) {
        return url && url.indexOf('.com/detail') !== -1;
      }
      if (!isSharingProductDetailUrl(link)) {
        return;
      }

      const channelMap = {
        shareTimeline: 'wxtimeline',
        shareAppMessage: 'wxchat',
        shareQQ: 'qqchat',
        shareQzone: 'qqzone',
      };

      const userId = store.get(store.LOGIN_UID);
      if (utils.isEmpty(userId)) {
        return;
      }
      const regex = new RegExp('productid=([^&]*)(&|$)');
      const match = link.match(regex);
      const productId = (match ? match[1] : '');
      fetch.post('/credit/share', {
        referenceId: productId,
        channel: channelMap[shareMethod],
      }, { silent: true }).then((res) => {
        if (utils.isEmpty(res.hint)) {
          return;
        }
        // toast.pop(res.hint);
      });
    }

    function shareLinkConstructor(link) {
      const guid = store.getGuid();
      if (link.indexOf('?') > 0) {
        // fromguid必定会有
        if (link.indexOf('fromguid') > 0) {
          link = link.replace(/(fromguid=)((.+?)-(.+?))+?(&|\b)/g, `$1${guid}$5`);
        } else {
          link += `&fromguid=${guid}`;
        }
        // 分享时删除fromclient参数
        if (link.indexOf('fromclient') > 0) {
          link = utils.delParamFromUrlString(link, 'fromclient');
        }
        // 分享时删除guid
        if (link.indexOf('guid') > 0) {
          link = utils.delParamFromUrlString(link, 'guid');
        }
      } else {
        link += `?fromguid=${guid}`;
      }

      // 添加fromuid
      const userId = store.get(store.LOGIN_UID);
      link = addParamToUrl(link, 'fromuid', userId, true);

      // 分享时的timestamp
      const sharets = new Date().getTime();
      link = addParamToUrl(link, 'sharets', sharets);

      // 分享时的mtfrom只接受url中的参数
      const mtfrom = utils.getUrlParam('mtfrom') || store.get('mtfrom', true);
      if (!utils.isEmpty(mtfrom) && link.indexOf('mtfrom') === -1) {
        link = addParamToUrl(link, 'mtfrom', mtfrom);
      }

      // brokeruid
      const brokeruid = store.get('brokeruid', true);
      if (link.indexOf('brokeruid') === -1 && !utils.isEmpty(brokeruid)) {
        link = addParamToUrl(link, 'brokeruid', brokeruid);
      }
      return link;
    }

    function addParamToUrl(link, key, value, deleteIfNotExist) {
      if (!utils.isEmpty(value)) {
        if (link.indexOf(key) > 0) {
          link = link.replace(new RegExp(`(${key}=)(.+?)(&|$)`, 'g'), `$1${value}$3`);
        } else {
          link += `&${key}=${value}`;
        }
      } else if (deleteIfNotExist && link.indexOf(key) > 0) {
        link = utils.delParamFromUrlString(link, key);
      }
      return link;
    }
  },

  /*
   以下是用户触发的api,不需要依赖ready函数
  */

  // 选择系统图片,options:
  // count: 1, // 默认9
  // sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
  // sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
  chooseImage(resolve, reject, options) {
    wx.chooseImage({
      count: options.count || 9,
      sizeType: options.sizeType || ['original', 'compressed'],
      sourceType: options.sourceType || ['album', 'camera'],
      success(res) {
        const { localIds } = res;
        const retArr = [];
        const asyncTask = [];
        localIds.forEach((item) => {
          const p = new Promise((resolve_, reject_) => {
            wx.getLocalImgData({
              localId: item.toString(),
              success(ret) {
                resolve_();
                let base64Data = ret.localData;
                if (base64Data.indexOf('data:image') === 0) {
                  retArr.push(base64Data);
                } else {
                  base64Data = `data:image/jpeg;base64,${base64Data.replace(/\n/g, '')}`;
                  retArr.push(base64Data);
                }
              },
            });
          });
          asyncTask.push(p);
        });
        Promise.all(asyncTask).then(() => {
          resolve(retArr);
        });
      },
    });
  },
  // 预览图片接口 options:
  // current: '', // 当前显示图片的http链接
  // urls: [] // 需要预览的图片http链接列表, required
  previewImage(resolve, reject, options) {
    wx.previewImage({
      current: options.current || options.urls[0],
      urls: options.urls,
    });
  },
  // 上传图片
  uploadImage(resolve, reject) {
    wx.uploadImage({
      localId: '',
      isShowProgressTips: 1,
      success(res) {
        const { serverId } = res;
        resolve(serverId);
      },
    });
  },
  // 下载图片
  downloadImage(resolve, reject) {
    wx.downloadImage({
      serverId: '',
      isShowProgressTips: 1,
      success(res) {
        const { localId } = res;
        resolve(localId);
      },
    });
  },
  // 获取网络类型
  getNetWorkType(resolve, reject) {
    wx.getNetWorkType({
      success(res) {
        resolve(res.networkType); // 2g,3g,4g,wifi;
      },
    });
  },
  // 根据坐标打开腾讯地图
  // lat: 0, // 纬度，浮点数，范围为90 ~ -90
  // lon: 0, // 经度，浮点数，范围为180 ~ -180。
  // name: '', // 位置名
  // address: '', // 地址详情说明
  // scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
  // infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
  openLocation(resolve, reject, location) {
    wx.openLocation({
      latitude: location.latitude,
      longitude: location.longitude,
      name: location.name,
      address: location.address,
      scale: location.scale,
      infoUrl: '',
    });
  },
  // 获取地理位置信息
  getLocation(resolve, reject, geoType) {
    wx.getLocation({
      type: geoType || 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success(res) {
        const { latitude } = res; // 纬度，浮点数，范围为90 ~ -90
        const { longitude } = res; // 经度，浮点数，范围为180 ~ -180。
        const { speed } = res; // 速度，以米/每秒计
        const { accuracy } = res; // 位置精度
        resolve(res);
      },
      fail(error) {
        reject(error);
      },
      cancel(error) {
        reject(error);
      },
    });
  },
  // 关闭当前窗口
  closeWindow(resolve, reject) {
    wx.closeWindow();
  },
  // 微信扫一扫
  scanQRCode(resolve, reject, needResult) {
    wx.scanQRCode({
      needResult: needResult ? 1 : 0,
      scanType: ['qrCode', 'barCode'],
      success(res) {
        console.log(123);
        resolve(res.resultStr);
      },
      fail(res) {
        reject(res);
      },
    });
  },
  // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”,具体菜单项参见微信官网附录
  hideMenu(resolve, reject, menuList) {
    wx.hideMenuItems({
      menuList,
    });
  },
  preventShare(resolve, reject) {
    hideMenu([
      'menuItem:share:appMessage',
      'menuItem:share:timeline',
      'menuItem:share:qq',
      'menuItem:share:QZone',
      'menuItem:share:weiboApp',
      'menuItem:favorite',
      'menuItem:share:facebook',
      'menuItem:share:QZone',
      'menuItem:copyUrl',
    ]);
  },
  // 要显示的菜单项
  showMenu(resolve, reject, menuList) {
    wx.showMenuItems({
      menuList,
    });
  },
  // 微信支付
  startPayment(resolve, reject, payObject) {
    wx.chooseWXPay({
      timestamp: payObject.timeStamp,
      nonceStr: payObject.nonceStr,
      package: payObject.package,
      signType: payObject.signType,
      paySign: payObject.paySign,
      success: (res) => { resolve(res); },
      fail: (res) => { reject(res); },
      cancel: (res) => { reject(res); },
    });
  },
};

const it = wxGenerator();

if (utils.isWeixin()) {
  setTimeout(() => {
    it.next(); // 开启
  }, 500);
}

// js api 执行流程
function* wxGenerator() {
  jobQueue.wrapper = wxWrapper;
  const param = yield wxWrapper.getWxParam(it);
  yield wxWrapper.setWxConfig(param, it, jobQueue);
  yield wxWrapper.setWxShare(null, null, {
    title: config.DEFAULT_SHARE_TITLE,
    desc: config.DEFAULT_SHARE_DESC,
    link: config.DEFAULT_SHARE_LINK,
    imgUrl: config.DEFAULT_SHARE_ICON,
  }, null, it);
  jobQueue.flushQueue();
}

function callFunction(functionName, ...params) {
  return new Promise((resolve, reject) => {
    jobQueue.enqueue(resolve, reject, functionName, params);
    jobQueue.flushQueue();
  });
}

function setWxShare(shareInfo, shareCallback) {
  return callFunction('setWxShare', shareInfo, shareCallback);
}

function chooseImage(options) {
  return callFunction('chooseImage', options);
}
function previewImage(options) {
  return callFunction('previewImage', options);
}
function uploadImage() {
  return callFunction('uploadImage');
}
function downloadImage() {
  return callFunction('downloadImage');
}
function getNetWorkType() {
  return callFunction('getNetWorkType');
}
function openLocation(location) {
  return callFunction('openLocation', location);
}
function getLocation(geoType) {
  return callFunction('getLocation', geoType);
}
function closeWindow() {
  return callFunction('closeWindow');
}
function scanQRCode(needResult) {
  return callFunction('scanQRCode', needResult);
}
function hideMenu(menuList) {
  return callFunction('hideMenu', menuList);
}
function preventShare() {
  return callFunction('preventShare');
}
function showMenu(menuList) {
  return callFunction('showMenu', menuList);
}
function startPayment(payObject) {
  return callFunction('startPayment', payObject);
}

export default {
  scanQRCode,
  closeWindow,
  getLocation,
  openLocation,
  getNetWorkType,
  downloadImage,
  uploadImage,
  previewImage,
  chooseImage,
  setWxShare,
  startPayment,
  preventShare,
  showMenu,
};
